<template>
    <div
        class="tema-list-item"
        :class="hover ? 'hover' : null"
        @mouseenter="hover = true"
        @mouseleave="hover = false"
        @click.prevent="onClick"
    >
        <div class="tema-list-item__image-container">
            <ImageFile :id="bilde" :alt="'Illustrasjon ' + tittel" />
        </div>
        <div>
            <TemaLink href="#" :id="id" :tittel="tittel" />
        </div>
    </div>
</template>

<script>
    import TemaLink from '../shared/TemaLink';
    import ImageFile from '../shared/ImageFile';
    import {useRoutes} from "@/composables/useRoutes";
    import {useRouter} from "vue-router";

    export default {
        props: {
            id: String,
            tittel: String,
            bilde: String,
            ingress: String
        },
        setup(props){
            const {routes} = useRoutes()
            const router = useRouter();

            const onClick = (e) => {
                if (e.ctrlKey || e.metaKey) {
                    let routeData = router.resolve({
                        name: routes.tema,
                        params: { id: props.id, title: props.tittel }
                    });
                    window.open(routeData.href, '_blank');
                } else {
                    router.push({
                        name: routes.tema,
                        params: {
                            id: props.id,
                            title: props.tittel
                        }
                    });
                }
            }

            return{
                onClick
            }
        },
        components: {
            TemaLink,
            ImageFile
        },
        data() {
            return {
                hover: false
            };
        },
    };
</script>
